import React from "react";
// eslint-disable-next-line import/no-cycle
import { GeneralBoxContent, GeneralBoxTitle, GeneralBoxWrapper } from "./style";

interface IGeneralBox {
	title: string;
	children: React.ReactNode;
	className?: string;
}

export const GeneralBox = ({ title, className, children }: IGeneralBox) => {
	return (
		<GeneralBoxWrapper className={className}>
			<GeneralBoxTitle>{title}</GeneralBoxTitle>
			<GeneralBoxContent>{children}</GeneralBoxContent>
		</GeneralBoxWrapper>
	);
};
